import { Component, HostBinding, OnInit } from '@angular/core';

import { LanguageService } from '../../../../../core/services/language.service';
import { RoutingService } from '../../../../../core/services/routing.service';
import { HttpOfferService } from '../../../../../core/services/http/http-offer.service';
import { Offer } from '../../../../../shared/models/entities/offer.entity';
import { SubscriptionTier } from '../../../../../shared/models/enums/subscription.enums';

@Component({
  selector: 'app-cgv',
  templateUrl: './cgv.component.html',
  styleUrls: ['./cgv.component.scss'],
})
export class CgvComponent implements OnInit {
  offers: Offer[];

  @HostBinding('class.content-tab') tabClass = true;
  @HostBinding('style.order') tabOrder = 2;

  SubscriptionTier = SubscriptionTier;

  constructor(
    public languageService: LanguageService,
    private routingService: RoutingService,
    private httpOfferService: HttpOfferService
  ) {
    this.routingService.itemChange$.next(this.routingService.getIndexOfTab('cgv'));
  }

  ngOnInit(): void {
    this.httpOfferService.list().subscribe((res) => {
      this.offers = res['hydra:member'].map((elt) => new Offer(elt));
    });
  }
}
